<template>
  <div>
    <Nav />
    <h3 class="inviteAddEm">Inviting registration</h3>
    <div class="inviteMain">
      <div class="inviteCon">
        <p>{{inviteTex}}</p>
        <div class="radioType">
          <el-radio v-model="radio" label="1" v-if="emailInvite">Email invitation</el-radio>
          <!-- <el-radio v-model="radio" label="2" v-if="QRCodeInvited">微信邀请</el-radio> -->
        </div>
        <div class="type" v-show="radio==='1'">
          <!-- <h4>邀请方式1：邮件邀请</h4> -->
          <el-form ref="form" class="inviteForm" :model="form" label-width="80px">
            <el-form-item label="From">
              <el-input :disabled="true" v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="E-mail">
              <el-input v-model="form.emails" placeholder="Please enter the email address of your friends"></el-input>
              <span>To multiple recipients, please separate the email addresses with English commas</span>
            </el-form-item>
            <el-form-item label="Subject">
              <el-input :disabled="true" v-model="form.title" style="width:200%;"></el-input>
            </el-form-item>
            <el-form-item label="send content">
              <div class="inviteEmailCon" v-html="form.emailCon"></div>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="sendEmail" :style="btnAllStyle">Send invitation email immediately</el-button>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="radio === '2'">
          <!-- <h4>邀请方式2：微信邀请</h4> -->
          <p style="padding:30px 0;">点击下方“即刻邀请好友”，手机扫描二维码获取电子邀请函，转发给好友或朋友圈即可邀请好友预登记；</p>
          <div class="inviteBtnbox"><el-button type="primary" :style="btnAllStyle" @click="showInviteModal = true">即刻邀请好友</el-button></div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showInviteModal"
      width="800px">
      <div class="inviteModalCon">
        <div class="inviteLeft">
          <div class="qrBox">
            <div id="qrCode" ref="qrCodeDiv"></div>
          </div>
          <div>
            <h5>微信扫描二维码，获取专属邀请函</h5>
            <p class="shareTipsP">然后点击右上角'...'，转发给朋友或朋友圈</p>
          </div>
        </div>
        <div class="inviteRight" v-if="QRCodeBanner">
          <img :src="QRCodeBanner" alt="">
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Nav from '../components/Nav'
import QRCode from 'qrcodejs2';
import api from '../api'
import regExp from '../utils/regExp.js'
import utils from '../utils'
export default {
  name: 'invite',
  components: {
    Nav
  },
  data() {
    return {
      radio: '1',
      form: {
        name: '',
        emails: '',
        title: '',
        emailCon: ''
      },
      showInviteModal: false,
      QRCodeBanner: '',
      ExhID: sessionStorage.getItem('ExhID'),
      inviteTex: '',
      msgInvite: true,
      emailInvite: true,
      QRCodeInvited: true,
      btnAllStyle: sessionStorage.getItem('btnAll') ? JSON.parse(sessionStorage.getItem('btnAll')).styles : {}
    }
  },
  watch: {
    showInviteModal(val1, val2) {
      setTimeout(() => {
        if (val1 === true) {
          this.bindQRCode()
        }
      }, 100);
    }
  },
  mounted() {
    this.getInviteStrategy()
    this.loadPageConfig()
    utils.setThemeColor()
  },
  methods: {
    loadPageConfig: function() {
      var param = {
        ExhID: this.ExhID,
        RegistType: 'pc',
        page: 'InvitationList',
        Language: 'en'
      }
      api.getPage(param).then(res => {
        if (res.data.status === 'OK') {
          res.data.promptinfo.map(item => {
            if (item.name === 'InvitationTex') {
              this.inviteTex = item.value
            }
            if (item.name === 'QRCodeUrl') {
              this.QRCodeUrl = item.value
            }
          })
          res.data.images.map(item => {
            if (item.name === 'QRCodeBanner') {
              this.QRCodeBanner = item.data[0]
            }
          })
          res.data.switchInfos.map(item => {
            if (item.name === 'MsgInvited') {
              this.msgInvite = item.data
            }
            if (item.name === 'EmailInvited') {
              this.emailInvite = item.data
            }
            if (item.name === 'QRCodeInvited') {
              this.QRCodeInvited = item.data
            }
          })
        } else {
          this.$alert(res.data.ErrorMsg)
        }
      })
    },
    getInviteStrategy() {
      var inviteUrl = ''
      var InviteType = sessionStorage.getItem('InviteType') || 'Person'
      let InviteCode = sessionStorage.getItem('InviteCode') || 0
      let InviteID = sessionStorage.getItem('noJmPsnID');
      inviteUrl = `${window.location.href.split('#')[0]}#/login?ExhID=${sessionStorage.getItem('ExhID')}&InviteID=${InviteID}&InviteType=${InviteType}&InviteCode=${InviteCode}`;
      api.getInviteStrategy({
        ExhID: sessionStorage.getItem('ExhID'),
        EntryPsjId: sessionStorage.getItem('PsjID'),
        InviteUrl: inviteUrl,
        Language:'en'
      }).then(res => {
        if (res.data.status === 'OK') {
          this.form.title = res.data.InviteTitle
          this.form.name = res.data.PsjName
          // this.form.emailCon = res.data.HtmlInfo


          var htmlString = res.data.HtmlInfo
          htmlString = htmlString.replace(/<a/, "<span");
          htmlString = htmlString.replace(/<\/a>/, "</span>");
          // var replacedHtmlString = htmlString.replace(/<a(.*?)>(.*?)<\/a>/, '<div$1>$2</div>');
          // console.log(htmlString);

          this.form.emailCon = htmlString
          
        }
      })
    },
    bindQRCode() {
      this.$refs.qrCodeDiv.innerHTML = '';
      var InviteType = sessionStorage.getItem('InviteType') || 'Person'
      let InviteCode = sessionStorage.getItem('InviteCode') || 0
      let InviteID = sessionStorage.getItem('noJmPsnID');
      // 生成卡号二维码
      let PsnQRCode = new QRCode(this.$refs.qrCodeDiv, {
        width: 127,
        height: 127,
        colorDark: 'black',
        colorLight: '#ffffff',
        text: `${this.QRCodeUrl}&InviteType=${InviteType}&InviteCode=${InviteCode}&InviteID=${InviteID}`
      })
      console.log(PsnQRCode)
    },
    sendEmail() {
      if (!this.form.emails) {
        this.$alert('Please enter at least one email address！')
        return false;
      } else {
        // 验证邮箱格式
        var tmpArr = this.form.emails.split(',')
        for (let i = 0; i < tmpArr.length; i++) {
          let tmpObj = tmpArr[i]
          if (!regExp.regCheckEmail.test(tmpObj)) {
            // this.$alert(`第${i + 1}个邮箱格式错误`)
            this.$alert(`${i + 1}th email format error`)
            return false;
          }
        }
      }
      var inviteUrl = ''
      var InviteType = sessionStorage.getItem('InviteType') || 'Person'
      let InviteCode = sessionStorage.getItem('InviteCode') || 0
      let InviteID = sessionStorage.getItem('noJmPsnID');
      inviteUrl = `${window.location.href.split('#')[0]}#/login?ExhID=${sessionStorage.getItem('ExhID')}&InviteID=${InviteID}&InviteType=${InviteType}&InviteCode=${InviteCode}`;
      // 发送邮件
      api.sendInviteEmial({
        ExhID: sessionStorage.getItem('ExhID'),
        EntryPsjId: sessionStorage.getItem('PsjID'),
        Emails: this.form.emails,
        InviteUrl: inviteUrl,
        Message: this.form.Message,
        Language:'en'
      }).then(res => {
        if (res.data.status === 'OK') {
          this.form.emails = ''
          this.$message({
            message: 'Email sent successfully!',
            type: 'success'
          });
        }
      })
    }
  }
}
</script>

<style>
.inviteEmailCon{
  padding: 10px;
  background: #F5F7FA;
  border:1px solid #E4E7ED;
  width: 610px;
  border-radius: 6px;
}
.qrBox{
  display: inline-block;
}
.inviteAddEm{
  text-align: left;
  font-size: 16px;
  font-weight: 600;
  padding: 60px 80px 30px;
  background: #fff;
  border-bottom: 1px solid #eee;
}
.inviteMain{
  background: #fff;
  padding: 14px 80px;
}
.radioType{
  padding: 20px 0;
}
.inviteForm{
  padding-top: 10px;
  width: 50%;
}
.inviteCon{
  min-height: 500px;
}
.inviteBtnbox{
  text-align: center;
  padding: 30px 0;
}
.inviteModalCon{
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-around;
}
.inviteModalCon .inviteLeft{
  width: 280px;
  text-align: center;
}
.shareTipsP{
  font-size: 12px;
  color: #999;
}
.inviteRight img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/InviteOpera.vue